const state = {
  isLogin: '',
  username: '',
  token: '',
  authMenu: '',
  baseMenu: '',
  authButton: '',
  showMenuList: [],
  hasMenu: false
}
export default state
